import * as Yup from "yup";

export const FormModalSchema = Yup.object().shape({
  name: Yup.string().required("Name is required").trim(),

  key: Yup.string().required("Key is required").trim(),

  parentId: Yup.mixed().nullable().optional(),

  path: Yup.string().required("Path is required").trim(),

  displayIndex: Yup.string()
    .required("Display index is required")
    .typeError("Display index must be a number")
    .min(0, "Display index must be greater than or equal to 0"),

  description: Yup.string()
    .nullable()
    .optional()
    .max(200, "Description must not exceed 200 characters")
    .trim(),

  permissions: Yup.mixed().nullable().optional(),
});

export const RolesModalSchema = Yup.object().shape({
  name: Yup.string().required("Name is required").trim(),
  key: Yup.string().required("Key is required").trim(),
});
